<!DOCTYPE html>
<html lang="en">
<head>
    <script>
        document.documentElement.classList.add('js-enabled');
        window.foucTimeout = setTimeout(function() {
            document.documentElement.classList.remove('js-enabled');
        }, 2000);
    </script>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta name="theme-color" content="#F8F9FA">
    <link rel="preload" as="font" href="fonts/Lato-Regular.woff2" type="font/woff2" crossorigin>
    <link rel="preload" as="font" href="fonts/Lato-Bold.woff2" type="font/woff2" crossorigin>
    <link rel="preload" as="font" href="fonts/Fredoka-SemiBold.woff2" type="font/woff2" crossorigin>
    <title>Our Rooms | Little Explorers Nursery</title>
    <link rel="icon" type="image/svg+xml" href="images/logo.svg">
    <meta name="description" content="Take a virtual tour of our beautiful, nurturing nursery spaces in Anytown.">
    <!-- 2026 AI Agent Discovery Links -->
    <link rel="alternate" type="text/plain" title="LLM Summary (Low Token)" href="/llms.txt">
    <link rel="alternate" type="text/plain" title="LLM Full Knowledge Base (High Token)" href="/llms-full.txt">
    <!-- Open Graph / Social Media -->
    <meta property="og:type" content="website">
    <meta property="og:url" content="https://littleexplorersnursery.example.com/rooms">
    <meta property="og:title" content="Our Nursery Rooms & EYFS Curriculum | Little Explorers Nursery">
    <meta property="og:description" content="Explore our beautiful, purpose-built childcare spaces and outdoor garden. We deliver an enriched EYFS curriculum for children aged 3 months to 5 years.">
    <meta property="og:image" content="https://littleexplorersnursery.example.com/images/og-image.jpg">
    <meta name="twitter:card" content="summary_large_image">
    <!-- Base CSS -->
    <link rel="stylesheet" href="css/style.css">
    <!-- Room Specific CSS (We will create this next) -->
    <link rel="stylesheet" href="css/components/rooms.css">
    <script type="module" src="js/lib/dotlottie/dotlottie-player.mjs"></script>
    
    <!-- 2026 Speculation Rules for Instant Navigation -->
    <script type="speculationrules">
    {
      "prerender": [{
        "source": "document",
        "where": {"href_matches": "/*"},
        "eagerness": "moderate"
      }]
    }
    </script>
    <script defer src="/vendor/gsap.min.js"></script>
    <script defer src="/vendor/ScrollTrigger.min.js"></script>
    <script type="module" src="/js/main.js"></script>
    <script type="module" src="/js/global-animations.js"></script>
    <script type="module" src="/js/rooms.js"></script>
</head>
<body>

    <!-- MOBILE NAVBAR START -->
    <nav class="mobile-navbar" aria-label="Mobile top bar">
        <a href="/" class="mobile-logo-link">
            <img src="images/logo.svg" alt="Little Explorers Nursery Logo" class="mobile-logo" width="45" height="44" loading="eager" fetchpriority="high">
        </a>
        <button type="button" class="mobile-menu-toggle" aria-label="Toggle navigation" aria-expanded="false">
            <span class="bar"></span>
            <span class="bar"></span>
        </button>
    </nav>

    <!-- MOBILE CURTAIN OVERLAY NAVIGATION -->
    <div class="mobile-menu-overlay" aria-hidden="true" style="display: none;">
        <nav class="mobile-overlay-nav">
            <ul class="mobile-overlay-list">
                <li><a href="/" class="mobile-overlay-link">Home</a></li>
                <li><a href="rooms" class="mobile-overlay-link active">Our Rooms</a></li>
                <li><a href="staff" class="mobile-overlay-link">Our Team</a></li>
                <li><a href="fees" class="mobile-overlay-link">Fees & Info</a></li>
                <li><a href="contact" class="mobile-overlay-link cta-pill">Book a Tour</a></li>
            </ul>
        </nav>
    </div>
    <!-- MOBILE NAVBAR END -->

    <!-- DESKTOP NAVBAR START -->
    <header class="site-header">
        <div class="container header-inner">
            <a href="/" class="logo-link">
                <img src="images/logo.svg" alt="Little Explorers Nursery Logo" class="site-logo" width="61" height="60" loading="eager" fetchpriority="high">
            </a>
            <nav class="nav-links">
                <a href="/">Home</a>
                <a href="rooms" class="active">Our Rooms</a>
                <a href="staff">Our Team</a>
                <a href="fees">Fees & Info</a>
            </nav>
            <div class="header-cta">
                <a href="contact" class="btn btn-primary">Book a Tour</a>
            </div>
        </div>
    </header>
    <!-- DESKTOP NAVBAR END -->

    <main>
        <!-- TOUR INTRO -->
        <section class="tour-intro section-padding text-center">
            <div class="container">
                <div class="section-header" style="margin-bottom: 0;">
                    <h1>Follow the 
                        <span class="crayon-wrap">
                            path
                            <!-- Highlight SVG -->
                            <svg class="crayon-svg highlight highlighter-yellow" viewBox="0 0 140 40" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                                <path d="M 10,20 C 50,17 90,23 130,20" fill="none" stroke="#F6CD99" stroke-width="22" stroke-linecap="round"></path>
                            </svg>
                        </span>
                    </h1>
                    <p>Click a picture to step inside and explore our beautiful spaces.</p>
                </div>
            </div>
        </section>

        <!-- THE TREASURE MAP -->
        <section class="treasure-map-section">
            <div class="container map-container">
                
                <!-- The Winding SVG Path (Background) -->
                <svg class="map-path-svg">
                    <!-- The Invisible Mask -->
                    <defs>
                        <mask id="path-mask">
                            <path class="mask-line" d="" fill="none" stroke="white" stroke-width="12" stroke-linecap="round"></path>
                        </mask>
                    </defs>

                    <!-- Background Trail (Muted Light Blue) -->
                    <path class="trail-bg" d="" fill="none" stroke="var(--color-primary-light)" stroke-width="6" stroke-linecap="round" stroke-dasharray="12 24" style="opacity: 0.15;"></path>
                    
                    <!-- Highlighted Treasure Map Trail (Premium Navy, revealed by mask) -->
                    <path class="trail-active" mask="url(#path-mask)" d="" fill="none" stroke="var(--color-text-main)" stroke-width="6" stroke-linecap="round" stroke-dasharray="12 24" style="opacity: 0.25;"></path>
                </svg>

                <!-- MAP NODES -->
                <div class="map-nodes">
                    
                    <!-- 1. Baby Room -->
                    <button class="map-node node-left" data-target="baby-room">
                        <!-- Playful Click Hint (above the polaroid) -->
                        <div class="click-me-hint">
                            <span class="click-me-text">Click Me</span>
                            <svg class="crayon-svg arrow" viewBox="0 0 60 80" preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false">
                                <path class="arrow-line" d="M 45,5 C 50,30 35,50 15,65" fill="none" stroke="var(--color-accent)" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path class="arrow-tip" d="M 25,50 L 15,65 L 30,70" fill="none" stroke="var(--color-accent)" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </div>
                        <div class="node-polaroid">
                            <img loading="lazy" src="images/photos/placeholder-room-4.webp" alt="Cozy baby cribs" width="600" height="600">
                        </div>
                        <div class="node-label">
                            <h2 class="node-title">Baby Room</h2>
                            <span class="node-tag">3m - 18m</span>
                        </div>
                    </button>

                    <!-- 2. Toddler Room -->
                    <button class="map-node node-right" data-target="toddler-room">
                        <div class="node-label">
                            <h2 class="node-title">Toddler Room</h2>
                            <span class="node-tag">18m - 2.5yrs</span>
                        </div>
                        <div class="node-polaroid">
                            <img loading="lazy" src="images/photos/pencildrawing.jpeg" alt="Wooden educational toys" width="600" height="600">
                        </div>
                    </button>

                    <!-- 3. Pre-School Room -->
                    <button class="map-node node-left" data-target="preschool-room">
                        <div class="node-polaroid">
                            <img loading="lazy" src="images/photos/placeholder-room-5.webp" alt="Pre-school activities" width="600" height="600">
                        </div>
                        <div class="node-label">
                            <h2 class="node-title">Pre-School Room</h2>
                            <span class="node-tag">2.5yrs - 5yrs</span>
                        </div>
                    </button>

                    <!-- 4. The Garden -->
                    <button class="map-node node-right" data-target="garden">
                        <div class="node-label">
                            <h2 class="node-title">The Garden</h2>
                            <span class="node-tag">Outdoor Wonder</span>
                        </div>
                        <div class="node-polaroid">
                            <img loading="lazy" src="images/photos/childingarden.jpeg" alt="Children exploring nature outdoors" width="600" height="600">
                        </div>
                    </button>

                    <!-- 5. Nursery Kitchen -->
                    <button class="map-node node-left" data-target="nursery-kitchen">
                        <div class="node-polaroid">
                            <img loading="lazy" src="images/photos/placeholder-room-6.webp" alt="Fresh fruits and vegetables on a cutting board" width="600" height="600">
                        </div>
                        <div class="node-label">
                            <h2 class="node-title">Nursery Kitchen</h2>
                            <span class="node-tag">Fresh Daily Meals</span>
                        </div>
                    </button>

                </div>
            </div>
        </section>

        <!-- PRE-FOOTER CTA START -->
        <section class="pre-footer section-padding text-center">
            <div class="container">
                
                <!-- Floating Background Lottie (Moved inside 1200px container) -->
                <div class="decor-lottie drawing-bg" aria-hidden="true" data-nosnippet>
                    <dotlottie-player src="images/animations/drawing.lottie" autoplay loop></dotlottie-player>
                </div>

                <h2>Experience our world for yourself</h2>
                <p>We would love to show you around our beautiful spaces and answer any questions you have about your child's early years journey.</p>
                <a href="contact" class="btn btn-primary btn-large">Book a Personal Tour</a>
            </div>
        </section>
        <!-- PRE-FOOTER CTA END -->

        <!-- FOOTER (Matches existing pages) -->
        <footer class="site-footer">
            <div class="container">
                <div class="footer-grid">
                    <div class="footer-col brand-col">
                        <h3 class="footer-logo-text"><span translate="no">Little Explorers Nursery</span></h3>
                        <p>A nurturing, home-from-home early years setting in the heart of Anytown, Anycity.</p>
                        <div class="footer-badges">
                            <a href="https://ratings.food.gov.uk/" target="_blank" rel="noopener noreferrer">
                                <img loading="lazy" src="images/svgs/fhrs-badge-5.svg" alt="Food Hygiene Rating 5" class="footer-badge-img" width="160" height="80">
                            </a>
                            <a href="https://reports.ofsted.gov.uk/" target="_blank" rel="noopener noreferrer" aria-label="Read our Ofsted Report">
                                <img loading="lazy" src="images/svgs/Ofsted_Good_GP_White.svg" alt="Ofsted Good Provider" class="ofsted-footer-badge" width="60" height="60">
                            </a>
                        </div>
                    </div>
                    <div class="footer-col links-col">
                        <h4>Explore</h4>
                        <ul>
                            <li><a href="/">Home</a></li>
                            <li><a href="rooms">Our Rooms</a></li>
                            <li><a href="staff">Our Team</a></li>
                            <li><a href="fees">Fees & Funding</a></li>
                            <li><a href="contact">Contact</a></li>
                        </ul>
                    </div>
                    <div class="footer-col contact-col">
                        <h4>Get in Touch</h4>
                        <address>
                            <ul>
                                <li><strong>A:</strong> <a href="https://maps.google.com/?q=13+Anytown+Green,+Anycity+AT1+5LB" target="_blank" rel="noopener noreferrer">13 Anytown Green, Anycity AT1 5LB</a></li>
                                <li><strong>T:</strong> <a href="tel:+442079460123">020 7946 0123</a></li> 
                                <li><strong>E:</strong> <a href="mailto:hello@littleexplorersnursery.example.com">hello@littleexplorersnursery.example.com</a></li>
                            </ul>
                        </address>
                        <h4 class="hours-title">Opening Hours</h4>
                        <p class="hours-text"><span>Mon - Fri: 8:00am - 6:00pm</span><span>Sat - Sun: Closed</span></p>
                    </div>
                </div>
                <div class="footer-bottom">
                    <p>&copy; <span id="current-year"></span> All Rights Reserved - <a href="https://selcreative.co.uk/" target="_blank" rel="noopener noreferrer">SEL Creative</a></p>
                    <div class="legal-links">
                        <a href="privacy">Privacy Policy</a>
                        <span class="divider">|</span>
                        <a href="safeguarding">Safeguarding Policy</a>
                    </div>
                </div>
            </div>
        </footer>
    </main>

    <!-- ========================================== -->
    <!-- MAGIC DOORS TRANSITION OVERLAY -->
    <!-- ========================================== -->
    <div class="transition-doors" aria-hidden="true" data-nosnippet>
        <div class="door door-left"></div>
        <div class="door door-right"></div>
        <img loading="lazy" src="images/logo.svg" alt="" class="door-logo" width="200" height="60">
    </div>

    <!-- ========================================== -->
    <!-- THE MODAL OVERLAYS (HYBRID HASH VIEWS) -->
    <!-- ========================================== -->
    <div id="room-modals-container" class="room-modals-container" aria-hidden="true" inert>
        
        <!-- Shared Close Button -->
        <div class="modal-nav">
            <button class="btn btn-close-modal" id="close-modal-btn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
                Back to Map
            </button>
        </div>

<!-- 1. Baby Room Modal -->
        <article class="room-modal" id="modal-baby-room">
            <div class="room-modal-inner">
                <div class="room-content-col">
                    <div class="room-fast-facts">
                        <span class="fact-pill">
                            <span class="mask-icon" style="-webkit-mask-image: url('images/icons/babycare.svg'); mask-image: url('images/icons/babycare.svg'); width: 16px; height: 16px; margin-right: 6px; transform: translateY(2px); background-color: var(--color-primary); display: inline-block;"></span>
                            3&nbsp;Months - 18&nbsp;Months
                        </span>
                        <span class="fact-pill">
                            <span class="mask-icon" style="-webkit-mask-image: url('images/icons/staff.svg'); mask-image: url('images/icons/staff.svg'); width: 16px; height: 16px; margin-right: 6px; transform: translateY(2px); background-color: var(--color-primary); display: inline-block;"></span>
                            1:3&nbsp;Staff Ratio
                        </span>
                    </div>
                    <h1>The Baby Room</h1>
                    <p class="lead-text">A deeply <strong>nurturing and calm environment</strong> where babies follow their own home routines.</p>
                    <div class="skimmable-text">
                        <p>We know that the transition from home to nursery is a huge step. The Baby Room provides a small-group atmosphere of warmth, safety, and care. We focus on:</p>
                        <ul>
                            <li><strong>Sensory Play:</strong> Exploring different textures—often rather messy—with safe items like ice cubes, jelly, and a dedicated mirror area.</li>
                            <li><strong>Music & Movement:</strong> Daily singing and music sessions led by our specialist, playing along with percussion instruments.</li>
                            <li><strong>Unconditional Comfort:</strong> We provide all premium wipes and nappies at no extra cost, making your busy life a little easier.</li>
                        </ul>
                    </div>
                    <div class="room-cta">
                        <a href="contact" class="btn btn-primary">Book a Tour</a>
                    </div>
                </div>
                <div class="room-gallery-col">
                    <img loading="lazy" src="images/photos/placeholder-2.webp" alt="Beautiful baby nursery" class="img-main" width="800" height="1000">
                    <img loading="lazy" src="images/photos/placeholder-room-7.webp" alt="Soft sensory toys" class="img-overlay float-up" width="500" height="500">
                </div>
            </div>
        </article>

        <!-- 2. Toddler Room Modal -->
        <article class="room-modal" id="modal-toddler-room">
            <div class="room-modal-inner">
                <div class="room-content-col">
                    <div class="room-fast-facts">
                        <span class="fact-pill">
                            <span class="mask-icon" style="-webkit-mask-image: url('images/icons/paintboard.svg'); mask-image: url('images/icons/paintboard.svg'); width: 16px; height: 16px; margin-right: 6px; transform: translateY(2px); background-color: var(--color-primary); display: inline-block;"></span>
                            18&nbsp;Months - 2.5 Years
                        </span>
                        <span class="fact-pill">
                            <span class="mask-icon" style="-webkit-mask-image: url('images/icons/puzzle.svg'); mask-image: url('images/icons/puzzle.svg'); width: 16px; height: 16px; margin-right: 6px; transform: translateY(2px); background-color: var(--color-primary); display: inline-block;"></span>
                            Child-Led Discovery
                        </span>
                    </div>
                    <h1>The Toddler Room</h1>
                    <p class="lead-text">Where <strong>curiosity thrives</strong> and toddlers embrace their world with enthusiasm!</p>
                    <div class="skimmable-text">
                        <p>Our toddlers enjoy a carefully balanced, fun-filled day. We ensure small groups so each child receives lots of individual attention to build upon their secure foundation.</p>
                        <ul>
                            <li><strong>Creative Play:</strong> Drawing, painting, and modelling with different materials including clay and dough.</li>
                            <li><strong>Weekly Yoga:</strong> The toddlers enjoy a weekly Yoga lesson right here in the nursery to develop focus and physical coordination.</li>
                            <li><strong>Growing Independence:</strong> As they become more confident at mealtimes, we also work closely with parents to gently introduce toilet training.</li>
                        </ul>
                    </div>
                    <div class="room-cta">
                        <a href="contact" class="btn btn-primary">Book a Tour</a>
                    </div>
                </div>
                <div class="room-gallery-col">
                    <img loading="lazy" src="images/photos/placeholder-3.webp" alt="Toddler playing with blocks" class="img-main" width="800" height="1000">
                    <img loading="lazy" src="images/photos/placeholder-room-8.webp" alt="Child painting" class="img-overlay float-down" width="500" height="500">
                </div>
            </div>
        </article>

        <!-- 3. Pre-School Room Modal -->
        <article class="room-modal" id="modal-preschool-room">
            <div class="room-modal-inner">
                <div class="room-content-col">
                    <div class="room-fast-facts">
                        <span class="fact-pill">
                            <span class="mask-icon" style="-webkit-mask-image: url('images/icons/yoga.svg'); mask-image: url('images/icons/yoga.svg'); width: 16px; height: 16px; margin-right: 6px; transform: translateY(2px); background-color: var(--color-primary); display: inline-block;"></span>
                            2.5 Years - 5 Years
                        </span>
                        <span class="fact-pill">
                            <span class="mask-icon icon-star" style="width: 16px; height: 16px; margin-right: 6px; transform: translateY(2px); background-color: var(--color-primary);"></span>
                            Specialist Teachers
                        </span>
                    </div>
                    <h1>The Pre-School Room</h1>
                    <p class="lead-text">Led directly by our Qualified Early Years Lead and specialist team, ensuring an <strong>outstanding foundation</strong> for school readiness.</p>
                    <div class="skimmable-text">
                        <p>With an exceptional adult-to-child ratio, we far exceed standard educational requirements by providing an incredible range of specialist sessions.</p>
                        <ul>
                            <li><strong>Resident Artist:</strong> A qualified early years teacher helps children design garden mosaics and create beautiful natural models.</li>
                            <li><strong>Language & Music:</strong> French is taught using stories and puppets, whilst our music specialist brings traditional tales to life through drama.</li>
                            <li><strong>Physical Wellbeing:</strong> Our visiting instructor leads weekly Yoga lessons that the children absolutely love getting stuck into!</li>
                        </ul>
                    </div>
                    <div class="room-cta">
                        <a href="contact" class="btn btn-primary">Book a Tour</a>
                    </div>
                </div>
                <div class="room-gallery-col">
                    <img loading="lazy" src="images/photos/placeholder-1.webp" alt="Bright pre-school room" class="img-main" width="800" height="1000">
                    <img loading="lazy" src="images/photos/placeholder-room-9.webp" alt="Child doing yoga" class="img-overlay float-up" width="500" height="500">
                </div>
            </div>
        </article>

        <!-- 4. The Garden Modal -->
        <article class="room-modal" id="modal-garden">
            <div class="room-modal-inner">
                <div class="room-content-col">
                    <div class="room-fast-facts">
                        <span class="fact-pill">
                            <span class="mask-icon" style="-webkit-mask-image: url('images/icons/leaf.svg'); mask-image: url('images/icons/leaf.svg'); width: 16px; height: 16px; margin-right: 6px; transform: translateY(2px); background-color: var(--color-primary); display: inline-block;"></span>
                            Custom Designed
                        </span>
                        <span class="fact-pill">
                            <span class="mask-icon" style="-webkit-mask-image: url('images/icons/plant.svg'); mask-image: url('images/icons/plant.svg'); width: 16px; height: 16px; margin-right: 6px; transform: translateY(2px); background-color: var(--color-primary); display: inline-block;"></span>
                            Nature & Play
                        </span>
                    </div>
                    <h1>The Garden</h1>
                    <p class="lead-text"><strong>Little Explorers Nursery</strong> features an expansive outdoor haven designed for natural discovery, fresh air, and imaginative adventure.</p>
                    <div class="skimmable-text">
                        <p>Our expansive garden is split into distinct zones, providing children with an incredible connection to the natural world.</p>
                        <ul>
                            <li><strong>Growing & Nature Zones:</strong> Children grow and pick their own vegetables, learn about nature, and explore fragrant herbs and plants.</li>
                            <li><strong>Sensory Play & Exploration:</strong> The perfect place for active games, sensory discovery, and hide-and-seek among natural greenery.</li>
                            <li><strong>The Timber Climbing Frame:</strong> We proudly funded our bespoke climbing wall by breaking a Nature & Play for the most people dressed as sunflowers!</li>
                        </ul>
                    </div>
                    <div class="room-cta">
                        <a href="contact" class="btn btn-primary">Book a Tour</a>
                    </div>
                </div>
                <div class="room-gallery-col">
                    <img loading="lazy" src="images/photos/placeholder-room-10.webp" alt="Outdoor play area" class="img-main" width="800" height="1000">
                    <img loading="lazy" src="images/photos/placeholder-room-11.webp" alt="Muddy hands planting" class="img-overlay float-up" width="500" height="500">
                </div>
            </div>
        </article>

        <!-- 5. Nursery Kitchen Modal -->
        <article class="room-modal" id="modal-nursery-kitchen">
            <div class="room-modal-inner">
                <div class="room-content-col">
                    <div class="room-fast-facts">
                        <span class="fact-pill">
                            <span class="mask-icon" style="-webkit-mask-image: url('images/icons/cheff.svg'); mask-image: url('images/icons/cheff.svg'); width: 16px; height: 16px; margin-right: 6px; transform: translateY(2px); background-color: var(--color-primary); display: inline-block;"></span>
                            Organic Ingredients
                        </span>
                        <span class="fact-pill">
                            <span class="mask-icon" style="-webkit-mask-image: url('images/icons/carrot.svg'); mask-image: url('images/icons/carrot.svg'); width: 16px; height: 16px; margin-right: 6px; transform: translateY(2px); background-color: var(--color-primary); display: inline-block;"></span>
                            5-Star Hygiene Rating
                        </span>
                    </div>
                    <h1>Nursery Kitchen</h1>
                    <p class="lead-text">Fueling growing bodies and minds with <strong>wholesome, freshly prepared</strong> home-cooked meals.</p>
                    <div class="skimmable-text">
                        <p>We work with a trained nutritionist and chef to ensure our rolling four-week menu expands little palates while providing essential nutrition.</p>
                        <ul>
                            <li><strong>Organic First:</strong> The children eat organic bread, meat, vegetables, fruit, and drink organic whole milk.</li>
                            <li><strong>Local Sourcing:</strong> We serve fresh seasonal fish delivered directly to the nursery from a local Anytown fishmonger.</li>
                            <li><strong>Garden to Table:</strong> We actively incorporate the vegetables the children have picked from our very own garden!</li>
                        </ul>
                    </div>
                    <div class="room-cta">
                        <a href="contact" class="btn btn-primary">Book a Tour</a>
                    </div>
                </div>
                <div class="room-gallery-col">
                    <img loading="lazy" src="images/photos/placeholder-room-12.webp" alt="Fresh fruits and vegetables" class="img-main" width="800" height="1000">
                    <img loading="lazy" src="images/photos/placeholder-room-13.webp" alt="Chef preparing healthy food" class="img-overlay float-down" width="500" height="500">
                </div>
            </div>
        </article>

    </div>

</body>
</html>
